<template>
    <div class="CAcon">
        <ca-activation
            type="primary" 
            class="CAbtn"
            icon="el-icon-lock" 
            @click="CAlogin">
            CA登录
        </ca-activation>

        <p>
            <a 
                :href="calc" 
                target="_blank" 
                style="color:rgb(255, 0, 0);font-size: 16px;">
                CA登录绑定流程
            </a>
        </p>

        <p>
            <a 
                :href="qudong" 
                target="_blank" 
                style="color: #a25ab6;font-size: 16px;">
                电子招投标数字证书助手
            </a>
        </p>
    </div>
</template>

<script>
import CaActivation from '@/components-sys/ca-activation'

export default {
    components: {
        CaActivation,
    },
    props: {
        source: {
            type: String,
            default: ''
        },
        roleCode: {
            type: String,
            default: ''
        },
    },
    data: () => ({
        calc:window._config.calc,
        qudong:window._config.qudong,
        caObjectVal:{},
        form:{}
    }),
    methods: {
        // 回车登录
        CAlogin(type){
            var that = this;
            that.form.caType = type;
            that.form.userType = that.roleCode;
            that.caObjectVal.character = that.source;
            // 签名
            useCA(that.form.caType, 'sign', that.caObjectVal, function (res) {
                that.form.sData = res.signData;
                //获取证书对象
                useCA(that.form.caType, 'getCertB64', that.caObjectVal, function (res) {
                    that.form.sCert = res.signCert;
                    useCA(that.form.caType, 'CAterm', that.caObjectVal, function (res) {
                        that.form.sYxq = res.dYxq;
                        //将结果data提交后台
                        $.post(`${that.$store.getters.ageUrl}/admin/caloginnew.json`, that.form, function (data, res) {
                            if(data.result){
                                // 调用store.js的calogin方法
                                that.$store.dispatch('views/login',{obj:data.tdata});
                            }else{
                                ShowMsg(data.msg,'error')
                            }
                        })
                    })
                })
            })
        },
    },
}
</script>

<style scoped lang="scss">
    .CAcon .CAbtn{ width:100%;height:45px;margin-top:35px; display: block; }
    .CAcon /deep/ .el-button{ width: 100% !important; }
    .CAcon p{ margin-top: 15px; text-align:right }
</style>